export function Loading() {
  return (
    <div
      className="flex h-96 w-full flex-col items-center justify-center gap-4"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="relative h-10 w-10">
        <div className="absolute inset-0 rounded-full border-2 border-zinc-200 dark:border-zinc-700" />
        <div className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-apcap border-r-apcap/40" />
      </div>
      <p className="text-sm font-medium tracking-tight text-zinc-600 dark:text-zinc-400">
        Carregando dados…
      </p>
    </div>
  );
}
